import { useCallback, useMemo, useState } from "react";
import { Guid } from "guid-typescript";
import { Signal } from "../services/signal";

export function useSignal(url: string): [Signal, string] {
  const [trigger, setTrigger] = useState<any>(null);
  const fn = useCallback(() => {
    setTrigger(Guid.create().toString());
  }, []);
  // One hub instance for the app's lifetime — url/fn are stable, so deps are intentionally empty
  // (recreating the Signal on every render would tear down and rebuild the live connection).
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const signal = useMemo(() => new Signal(url, fn), []);

  return [signal, trigger];
}
